// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrText } from '@ion/components';

import FeatureGate from 'app/launch-darkly/gates/feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import allowRowClick from './allow-row-click';

function determineStyleNames(row) {
  const isSemiBold = row.deployedRevision && row.deployedConsentCategory !== row.consentCategory?.code;
  if (isSemiBold) {
    return 'sm semiBold';
  }

  return 'sm';
}

const ConsentCategoryCell = row => {
  const styleNames = determineStyleNames(row);
  const category = row.consentCategory;
  const textProps = {
    component: 'span',
    styleNames,
    ...allowRowClick,
  };
  return (
    <FeatureGate flagName={FEATURE_FLAGS.configurableConsentMvp}>
      <MrText {...textProps}>
        <FeatureGate flagName={FEATURE_FLAGS.ecmConfigurableConsent} fallback={'-'}>
          {category ? `${category.code} - ${category.name}` : '-'}
        </FeatureGate>
      </MrText>
    </FeatureGate>
  );
};
export default ConsentCategoryCell;
